import {jsx as $4MPRY$jsx} from "react/jsx-runtime";
import {useRef as $4MPRY$useRef, useEffect as $4MPRY$useEffect, useState as $4MPRY$useState, useMemo as $4MPRY$useMemo} from "react";



function $090815f5086f7f29$var$usePrevious(value) {
    const ref = $4MPRY$useRef();
    $4MPRY$useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
function $090815f5086f7f29$export$d2589202ac9c89c3(tabs, defaultTab) {
    const state = $4MPRY$useState();
    const [selectedTab, setSelectedTab] = state;
    const activeIndex = $4MPRY$useMemo(()=>{
        if (selectedTab) return tabs.indexOf(selectedTab);
        return -1;
    }, [
        selectedTab,
        tabs
    ]);
    const previousActiveIndex = $090815f5086f7f29$var$usePrevious(activeIndex);
    $4MPRY$useEffect(()=>{
        if (tabs.length === 0) {
            setSelectedTab(undefined);
            return;
        }
        if (selectedTab === null || selectedTab && tabs.includes(selectedTab)) return;
        if (typeof previousActiveIndex === "number" && previousActiveIndex >= 0 && (tabs[previousActiveIndex] || tabs[previousActiveIndex - 1])) {
            setSelectedTab(tabs[previousActiveIndex] || tabs[previousActiveIndex - 1]);
            return;
        }
        if (defaultTab === null) return;
        setSelectedTab(defaultTab && tabs.includes(defaultTab) ? defaultTab : tabs[0]);
    }, [
        selectedTab,
        defaultTab,
        tabs
    ]);
    return state;
}
function $090815f5086f7f29$export$3d96ec278d3efce4({ children: children , render: render = "lazy" , ...props }) {
    const [shouldRender, setShouldRender] = $4MPRY$useState(render === "always");
    $4MPRY$useEffect(()=>{
        if (props.hidden) return;
        setShouldRender(true);
    }, [
        props.hidden
    ]);
    return(/*#__PURE__*/ $4MPRY$jsx("div", {
        ...props,
        children: shouldRender ? children : null
    }));
}


export {$090815f5086f7f29$export$d2589202ac9c89c3 as useTabs, $090815f5086f7f29$export$3d96ec278d3efce4 as TabPanel};
//# sourceMappingURL=module.js.map
